import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notifications', {
	state: () => ({
		show: false,
		message: '',
		color: 'info',
		timeout: 5000
	}),

	actions: {
		showNotification({ message, color = 'info', timeout = 5000 }) {
			this.message = message;
			this.color = color;
			this.timeout = timeout;
			this.show = true;
		},

		showError(message) {
			this.showNotification({ message, color: 'error', timeout: 6000 });
		},

		showSuccess(message) {
			this.showNotification({ message, color: 'success', timeout: 4000 });
		},

		showWarning(message) {
			this.showNotification({ message, color: 'warning', timeout: 5000 });
		},

		showInfo(message) {
			this.showNotification({ message, color: 'info', timeout: 4000 });
		},

		hide() {
			this.show = false;
		}
	}
});
